import { tagEstado } from '../core/componentes.js';
import { contratoDe, contratosVisibles, importeDe, precioDe } from '../core/dominio.js';
import { S } from '../core/estado.js';
import { cant, esc, eur, fecha, num } from '../core/formato.js';
import { db } from '../data/db.js';

/* =====================================================================
   CERTIFICACIONES
   ===================================================================== */
/* Se agrupa por la certificación de verdad (i.certificacion), no por rango
   de fechas: con "el periodo no se cierra", una imputación tardía puede
   tener fecha de un mes anterior y aun así pertenecer a esta certificación.
   El importe de cada grupo suma el precio ya congelado de cada imputación,
   no cantidad×precio actual (que pudo cambiar después). */
export function lineasCert(cert){
  const imps = db.imputaciones.filter(i=>i.certificacion===cert.id);
  const agrup = {};
  imps.forEach(i=>{ const p=precioDe(i.precio); if(!agrup[p.id]) agrup[p.id]={p,cn:0,imp:0}; agrup[p.id].cn+=i.cantidad; agrup[p.id].imp+=importeDe(i); });
  return Object.values(agrup);
}

export function listaCertificaciones(certs){
  certs = certs.slice().sort((a,b)=>b.fecha.localeCompare(a.fecha));
  if(!certs.length) return `<div class="card vacio"><h4>Todavía no hay certificaciones</h4><p>Emite la primera cuando tengas trabajo validado.</p></div>`;
  return `<div class="grid" style="gap:14px">${certs.map(ct=>{
    // Base/IVA/total se guardaron al emitir y no se recalculan: si el IVA del
    // contrato cambia después, esta certificación conserva el que tenía.
    const c = contratoDe(ct.contrato), ls = lineasCert(ct);
    const pecBase = ct.base+ct.gg+ct.bi;
    const pctIva = pecBase ? num(ct.iva/pecBase*100, 0) : c.iva;
    return `<div class="card">
      <div class="card-h"><div><div class="eyebrow" style="margin:0">${esc(c.expediente)} · Certificación nº ${ct.numero}</div>
        <h3 style="margin-top:3px">${esc(c.nombre)}</h3>
        <div class="sub">Periodo ${fecha(ct.desde)} — ${fecha(ct.hasta)} · Emitida ${fecha(ct.fecha)}</div></div>
        <div style="text-align:right">${tagEstado(ct.estado)}
          <div class="mono" style="font-size:19px;font-weight:600;margin-top:6px">${eur(ct.total)}</div></div></div>
      <div class="tabla-wrap"><table>
        <thead><tr><th>Código</th><th>Unidad de obra</th><th class="num">Medición</th><th class="num">Precio</th><th class="num">Importe</th></tr></thead>
        <tbody>${ls.map(l=>`<tr><td class="cod">${esc(l.p.codigo)}</td><td>${esc(l.p.desc)}</td>
          <td class="num">${cant(l.cn)} ${esc(l.p.ud)}</td><td class="num">${num(l.p.precio)} €</td><td class="num"><b>${eur(l.imp)}</b></td></tr>`).join('')}
          <tr style="background:#FAFCFD"><td colspan="4" class="num" style="font-weight:600">Base imponible (ejecución material)</td><td class="num mono" style="font-weight:600">${eur(ct.base)}</td></tr>
          <tr style="background:#FAFCFD"><td colspan="4" class="num">Gastos generales</td><td class="num mono">${eur(ct.gg)}</td></tr>
          <tr style="background:#FAFCFD"><td colspan="4" class="num">Beneficio industrial</td><td class="num mono">${eur(ct.bi)}</td></tr>
          <tr style="background:#FAFCFD"><td colspan="4" class="num">IVA ${pctIva} %</td><td class="num mono">${eur(ct.iva)}</td></tr>
          <tr style="background:var(--ink);color:#fff"><td colspan="4" class="num" style="font-weight:600;border:none">Total</td><td class="num mono" style="font-weight:600;border:none">${eur(ct.total)}</td></tr>
        </tbody></table></div>
      <div style="display:flex;gap:8px;justify-content:flex-end;border-top:1px solid var(--linea);padding:12px 18px">
        <button class="btn btn-s" data-act="descargar" data-t="Certificación ${ct.numero} de ${esc(c.expediente)} en PDF">Descargar PDF</button>
        <button class="btn btn-s" data-act="descargar" data-t="Relación valorada en Excel">Exportar a Excel</button></div>
    </div>`;}).join('')}</div>`;
}

export function vistaCertificaciones(){
  const admin = S.usuario.rol==='admin';
  const contratos = contratosVisibles();
  const cs = contratos.map(c=>c.id);

  const pendientes = contratos.map(c=>{
    const imps = db.imputaciones.filter(i=>i.contrato===c.id && i.estado!=='certificada');
    return {c, n:imps.length, importe:imps.reduce((s,i)=>s+importeDe(i),0), antigua:imps.length?imps.map(i=>i.fecha).sort()[0]:null};
  }).filter(x=>x.n>0);

  let certs = db.certificaciones.filter(x=>cs.includes(x.contrato));
  if(S.filtroCertContrato!=='todos') certs = certs.filter(x=>x.contrato===S.filtroCertContrato);

  return `<div class="page-head">
    <div><div class="eyebrow">Facturación</div><h1>Certificaciones</h1>
      <p>Normalmente mensuales, pero sin cerrar el periodo por narices: cada certificación arrastra también lo que se registró tarde de meses anteriores.</p></div>
    ${admin?`<button class="btn btn-p" data-act="nueva-certificacion">Emitir certificación</button>`:''}</div>
  ${pendientes.length?`<div class="card" style="margin-bottom:16px"><div class="card-h"><div><h3>Pendiente de certificar</h3>
    <div class="sub">Trabajo validado o en borrador que todavía no está en ninguna certificación</div></div></div>
    <div class="tabla-wrap"><table>
      <thead><tr><th>Contrato</th><th class="num">Imputaciones</th><th class="num">Importe</th><th>Más antigua</th>${admin?'<th></th>':''}</tr></thead>
      <tbody>${pendientes.map(x=>`<tr>
        <td><span class="cod">${esc(x.c.expediente)}</span> ${esc(x.c.nombre)}</td>
        <td class="num">${x.n}</td>
        <td class="num"><b>${eur(x.importe)}</b></td>
        <td class="mono" style="font-size:12.5px">${fecha(x.antigua)}</td>
        ${admin?`<td><button class="btn btn-x" data-act="nueva-certificacion" data-c="${x.c.id}">Emitir</button></td>`:''}
      </tr>`).join('')}</tbody></table></div></div>`:''}
  <div style="display:flex;margin-bottom:16px">
    <select data-act="filtro-cert-contrato" style="margin-left:auto">
      <option value="todos" ${S.filtroCertContrato==='todos'?'selected':''}>Todos los contratos</option>
      ${contratos.map(c=>`<option value="${c.id}" ${S.filtroCertContrato===c.id?'selected':''}>${esc(c.expediente)} · ${esc(c.nombre)}</option>`).join('')}
    </select>
  </div>
  ${listaCertificaciones(certs)}`;
}

